import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import * as moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';
// import { Table, TableBody, TableCell, TableHead, TableRow, TablePagination, withStyles } from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
// import { DebounceInput } from 'react-debounce-input';
import loader from '../../images/Spin-1s-107px.gif';


import {
    getEnrollForPartnerUser,
    partnerUserDetail,
    getConsumerUser,
    getBusinessUserAffilate
} from '../../Actions/actions';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#fff',
        color: '#525659',

    },
    body: {
        fontSize: 14,

    },
}))(TableCell);


class UserDetailContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settlementDataAffiliateData: [],
            userid: localStorage.getItem('userId'),
            affiliateType: '',
            GetAffiliateUserData: '',
            rowsPerPage: 10,
            pageNumber: 1,
            searchKeyword: '',
            isLoader: false,
            sortBy: ''
        };

    }


    async componentDidMount() {
        const { match: { params } } = this.props
        this.setState({
            isLoader: true
        })
        if (params.roleName === 'Business-User') {
            this.props.getBusinessUserAffilate(params.id);
        } else {
            this.props.getConsumerUser(params.id);
        }

        this.fetchData();
    }

    componentWillUnmount() {

        this.props.partnerUserDetail([]);
    }



    fetchData = () => {
        const { rowsPerPage, pageNumber, searchKeyword, } = this.state
        const { match: { params } } = this.props
        this.setState({
            isLoader: true
        })
        this.props.getEnrollForPartnerUser({
            pageNumber: pageNumber,
            pageSize: rowsPerPage,
            searchKeyword: searchKeyword,
            userId: params.id,
            catgoryId: 0,
            sortBy: '',
        });
    }


    componentDidUpdate() {
        const {
            getEnrollmentUserDataCount
        } = this.props.data;
        const {
            settlementDataAffiliateData
        } = this.state;

        if (getEnrollmentUserDataCount !== settlementDataAffiliateData) {
            this.setState({
                settlementDataAffiliateData: getEnrollmentUserDataCount,
                isLoader: false
            })
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({
            pageNumber: parseInt(newPage, 10)
        }, () => {
            this.fetchData()
        })
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10)
        }, () => {
            this.fetchData()
        })
    };

    render() {
        const {
            rowsPerPage,
            pageNumber,
            searchKeyword,
            isLoader,
        } = this.state;
        const { match: { params }, data: { getEnrollmentUserDataCount, BusinessUserProfileDataAffilate, ConsumerUserData } } = this.props

        return (
            <div className="">
                {isLoader === true ? (
                    <div className="loader">
                        <img src={loader} alt="" />
                    </div>
                ) : ''}

                <div className="tab-container-inner">
                    <div className="breadcrumbs">
                        <span>
                            Users
                   </span>
                        <span>
                            >
                   </span>

                        <span>
                            <Link to={`/userDetail/${params.id}/${params.roleName}`} >
                                {params.roleName === 'Business-User' ? `${BusinessUserProfileDataAffilate.firstName} ${BusinessUserProfileDataAffilate.lastName}` : `${ConsumerUserData.firstName} ${ConsumerUserData.lastName}`}
                            </Link>
                        </span>
                    </div>
                    <div className="p-user-detail">
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                BUSINESS NAME
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? BusinessUserProfileDataAffilate.companyName : ''}
                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                SUBSCRIPTION
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? BusinessUserProfileDataAffilate.planName : ConsumerUserData.planName}

                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                EINS
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? BusinessUserProfileDataAffilate.totalTaxId : ConsumerUserData.totalTaxId}

                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                JOIN DATE
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? moment(BusinessUserProfileDataAffilate.createdAt !== undefined ? BusinessUserProfileDataAffilate.createdAt : '').format('MM-DD-YYYY') !== 'Invalid date' ? moment(BusinessUserProfileDataAffilate.createdAt !== undefined ? BusinessUserProfileDataAffilate.createdAt : '').format('MM/DD/YYYY') : 'TBA' : moment(ConsumerUserData.createdAt !== undefined ? ConsumerUserData.createdAt : '').format('MM-DD-YYYY') !== 'Invalid date' ? moment(ConsumerUserData.createdAt !== undefined ? ConsumerUserData.createdAt : '').format('MM/DD/YYYY') : 'TBA'}

                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label center-align">
                                ACTIVE
                             </div>
                            <div class="p-user-details center-align">
                                True
                             </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                NAME
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? `${BusinessUserProfileDataAffilate.firstName} ${BusinessUserProfileDataAffilate.lastName}` : `${ConsumerUserData.firstName} ${ConsumerUserData.lastName}`}
                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                POSITION
                             </div>
                            <div class="p-user-details">
                                {params.roleName === 'Business-User' ? BusinessUserProfileDataAffilate.companyTitle : ''}

                            </div>
                        </div>
                        <div className="p-user-detail-col">
                            <div class="p-user-label">
                                EMAIL
                             </div>
                            <div class="p-user-details email-link">
                                {params.roleName === 'Business-User' ? BusinessUserProfileDataAffilate.email : ConsumerUserData.email}

                            </div>
                        </div>
                    </div>
                    <div className="card-table-outer">
                    <div className="table-filter p-user-detail-filter">
                        <h3 className="table-filter-tittle">Enrollments
                        {/* <span> {getEnrollmentUserDataCount && getEnrollmentUserDataCount.result && (<span>({getEnrollmentUserDataCount.result.totalCount})</span>)} </span> */}
                        </h3>
                        <div className="filter-form">
                            {/* <div className="input-search-outer">
                                <DebounceInput
                                    placeholder="Search"
                                    type="search"
                                    // className={className}
                                    debounceTimeout={500}
                                    onChange={(evet) => {

                                        this.setState({
                                            searchKeyword: evet.target.value
                                        }, () => {
                                            this.fetchData()
                                        })
                                    }}
                                    forceNotifyByEnter={false}
                                    value={searchKeyword}
                                />

                                <SearchIcon className="p-serch-icon " />
                                <SearchIcon className="p-serch-icon " />
                            </div> */}
                        </div>
                    </div>
                    <div className="p-table-outer p-table-user-detail">
                        {getEnrollmentUserDataCount && getEnrollmentUserDataCount.code === 200 ? (
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell>Settlement Name</CustomTableCell>
                                        <CustomTableCell >Category</CustomTableCell>
                                        <CustomTableCell >Filing Deadline</CustomTableCell>
                                        <CustomTableCell >Status</CustomTableCell>

                                    </TableRow>
                                </TableHead>

                                {console.log('getEnrollmentUserDataCount.result', getEnrollmentUserDataCount.result)}
                                <TableBody className="p-table-body">{
                                    getEnrollmentUserDataCount.result ?
                                        getEnrollmentUserDataCount.result.records.map((item) => (
                                            <TableRow key={item.userId} >
                                                <CustomTableCell >{item.shortName}</CustomTableCell>
                                                <CustomTableCell >
                                                    {item.categoryName}
                                                </CustomTableCell>
                                                <CustomTableCell >{item.settlementImportantDateDto !== undefined ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM-DD-YYYY') !== 'Invalid date' ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM/DD/YYYY') : 'TBA' : ''}</CustomTableCell>
                                                <CustomTableCell >{item.enrollmentStatus}</CustomTableCell>

                                                <CustomTableCell > <Link
                                                    // to="/userDetail"
                                                    to={`/settlementAffiliate/${item.id}`}
                                                >
                                                    View
                </Link></CustomTableCell>
                                            </TableRow>
                                        ))
                                        : (<TableRow  >
                                            <CustomTableCell >Record Not found</CustomTableCell></TableRow>)
                                }</TableBody>




                            </Table>) : getEnrollmentUserDataCount.code === 404 ? (

                                <Table >
                                    <TableHead>
                                        <TableRow>
                                            <CustomTableCell>Settlement Name</CustomTableCell>
                                            <CustomTableCell >Category</CustomTableCell>
                                            <CustomTableCell >Filing Deadline</CustomTableCell>
                                            <CustomTableCell >Status</CustomTableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableRow  >
                                        <CustomTableCell >Record Not found</CustomTableCell></TableRow>
                                </Table>
                            ) : ""}
                    </div>
                    <Pagination 
                        count={getEnrollmentUserDataCount.result && getEnrollmentUserDataCount.result.totalCount > getEnrollmentUserDataCount.result.pageSize ? Math.ceil(getEnrollmentUserDataCount.result.totalCount/getEnrollmentUserDataCount.result.pageSize) : 1} variant="outlined" shape="rounded"
                        // count={settlementRefeDataAffiliateData.result && Math.round(settlementRefeDataAffiliateData.result.totalCount/settlementRefeDataAffiliateData.result.pageSize)} variant="outlined" shape="rounded"
                        onChange={this.handleChangePage}
                        page={pageNumber}
                        className="custom-pagination"
                    />
</div>
                    {/* <TablePagination
                        component="div"
                        count={getEnrollmentUserDataCount && getEnrollmentUserDataCount.result && getEnrollmentUserDataCount.result.totalCount ? getEnrollmentUserDataCount.result.totalCount : 0}
                        rowsPerPage={rowsPerPage}
                        page={pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> */}
                </div>

            </div>
        );
    }
}



const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getEnrollForPartnerUser,
            getConsumerUser,
            partnerUserDetail,
            getBusinessUserAffilate
        },
        dispatch,
    );

export default
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(UserDetailContainer);
